import { Component, ElementRef, HostListener, inject, Inject, OnInit, ViewChild, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { Router, RouterModule } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { FilterBenefitsService } from '../../services/filter-benefits.service';
import { BenefitService } from '../../../main/modules/benefits/benefit.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzButtonModule, NzInputModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
  constructor(private router: Router) { }
  @ViewChild('menuContainer') menuContainer! : ElementRef;

  storageService = inject(StorageService)
  filterBenefitsService = inject(FilterBenefitsService)
  lastRoute: string ='';
  isInListBeneficies = true;
  allCategories: { id: number, nombre: string }[] = [];
  benefitService  = inject(BenefitService)
  isClickCategorie : boolean= false;
  viewNav: boolean = false;
  viewNavMobile: boolean = false;
  viewBar: boolean = false;
  ngOnInit(): void {
    this.getCategories();
  }
navigateToProfile(): void {
  if (this.storageService.isLoggedIn) {
    const documentNumber = this.storageService.documentNumber;
    this.router.navigate(['/profile']);
  } else {
    this.router.navigate(['/auth/login'], { queryParams: { redirectTo: '/profile' } });
  }
}
showNav(){
  this.viewNav = !this.viewNav
}
showNavMobile(){
  this.viewNavMobile = !this.viewNavMobile
}
getCategories(){
      const request = {
      Texto: '',
      IdRubro: 0,
      IdComercio: 0,
      DescuentoValor: 0,
      DescuentoTexto: '',
      AplicaLunes: false,
      AplicaMartes: false,
      AplicaMiercoles: false,
      AplicaJueves: false,
      AplicaViernes: false,
      AplicaSabado: false,
      AplicaDomingo: false,
      CurrentLatitud: 0,
      CurrentLongitud: 0,
      MaxDistanciaMetros: 0,
      IncluirSucursales: false,
      IncluirRubroTracking: true,
      IncluirRubrosBusqueda: false
    };
   this.benefitService.getAllBenefits(request).subscribe(res => {


      this.allCategories = res
        .filter((b: any) => b.RubroTracking?.Nombre && b.IdRubroTracking && b.RubroTracking.Activo)
        .map((b: any) => ({ id: b.IdRubroTracking, nombre: b.RubroTracking.Nombre }))
        .filter((v, i, a) => i === a.findIndex(c => c.id === v.id))
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
    });
}
get isLoggedIn(): boolean {
  return this.storageService.isLoggedIn;
}

get sessionText(): string {
  return this.isLoggedIn ? 'Mi perfil' : 'Iniciar sesión';
}
viewCategories(){
  this.isClickCategorie= !this.isClickCategorie;
}

@HostListener('document:click', ['$event'])
onClickOutside(event:Event){
  if(this.menuContainer && !this.menuContainer.nativeElement.contains(event.target)){
    this.isClickCategorie=false
  }
}
ViewMobileBar(show :boolean ){
  this.viewBar= show;
}
isListado():boolean{
  if(this.router.url === '/beneficios/listado'){
    return true;
  }
  return false;
}
changeLastRoute(){
  this.lastRoute = this.router.url;
}
filterByName(event: Event){
  const currentUrl= this.router.url;
  const text = (event?.target as HTMLInputElement).value;
  if(text.length == 1 && currentUrl == '/beneficios/listado' ){
   
  }
  if(this.router.url !== '/beneficios/listado'){
    this.lastRoute = this.router.url;
    this.isInListBeneficies= false;
  }
  
  if(text.trim() == ''  && this.lastRoute !== '/beneficios/listado' ) {
    this.router.navigate([`${this.lastRoute}`])
  }else if(text !== '' && currentUrl !== '/beneficios/listado'){
    this.router.navigate(['/beneficios/listado'])
  }
   this.filterBenefitsService.setText(text);


}
filterByCategorie(id:number){
  this.router.navigate(['/beneficios/listado/'+id])
  this.viewNavMobile = false
  this.isClickCategorie= false
}
}
